module.exports = __webpack_public_path__ + "img/jc@2x.06265192.png";